import { ApplicationModule } from '@/components/modules/Application/ApplicationModule';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_APPLICATION: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.APPLICATION,
  schemesByRoles: [
    {
      roles: [APP_ROLES.MERCHANT, APP_ROLES.CHANNEL, APP_ROLES.AGENT],
      titleTextId: 'NEW_APPLICATION',
      widgets: [
        {
          id: WIDGETS.APPLICATION_PAGE_TITLE,
          roles: [APP_ROLES.MERCHANT, APP_ROLES.CHANNEL, APP_ROLES.AGENT],
          props: {},
          notShownInRightMenu: true,
        },
      ],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <ApplicationModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT, APP_USER_TYPES.CHANNEL, APP_USER_TYPES.AGENT],
          }}
        />
      ),
    },
  ],
};
